<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Şifre Değiştirt</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <li class="breadcrumb-item active">Şifre Değiştirt</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Şifre Değiştirt
              </div>
              <div class="card-body table-responsive p-0">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th># | <input @click="selectAllUsers" type="button" value="Tüm kullanıcıları seç"
                            class="btn btn-info"></th>
                        <th>Kullanıcı adı</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in datatable" :key="item.id">

                        <td><input type="checkbox" :id="'checkbox_' + item.id" v-model="selectedUsers[item.id]"></td>

                        <td>
                          {{ item.username }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <button type="button" class="btn btn-primary text-center" @click="handleSaveClick">
                            Kaydet
                          </button>
                        </td>
                        <td v-if="datatable.length == 0" colspan="3" class="text-center">
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="perPage" @paginate="pagination" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->


  </div>
  <!-- /.content-wrapper -->
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      perPage: 10,
      rows: 0,
      userList: [],
      overlay: false,
      datatable: [],
      selectedUsers: {},
      allUsersSelected: false,
      department: {
        name: "",
        description: "",
      },
    };
  },
  methods: {
    pagination(value) {
      this.page = value;
      var count = (value - 1) * this.perPage;
      this.datatable = this.userList.slice(count, count + this.perPage);
    },
    getDatas() {
      this.overlay = true;
      this.$http.get(`UserLogs/UserList/`).then((response) => {
        this.userList = response.data;
        this.datatable = this.userList.slice(0, this.perPage);
        this.rows = this.userList.length;
        this.updateDatatable();
        this.overlay = false;
      });
    },
    updateDatatable() {
      // Update the datatable with the data for the current page
      var count = (this.page - 1) * this.perPage;
      this.datatable = this.userList.slice(count, count + this.perPage);
    },
    selectAllUsers() {
      this.allUsersSelected = !this.allUsersSelected;

      // When the "Select all user" button is clicked, we set all user IDs to selectedUsers object
      if (this.allUsersSelected) {
        this.userList.forEach(item => {
          this.$set(this.selectedUsers, item.id, true);
        });
      } else {
        this.selectedUsers = {};
      }
    },
    toggleUserSelection(userId) {
      // Update the selectedUsers object when individual checkboxes are clicked
      this.$set(this.selectedUsers, userId, !this.selectedUsers[userId]);
    },
    handleSaveClick() {
      // Your save logic goes here
      const selectedUserIDs = Object.keys(this.selectedUsers).filter(id => this.selectedUsers[id]);
      if (selectedUserIDs.length === 0) {
        // Show an toastr if no user is selected
        toastr.warning("Lütfen en az bir kullanıcı seçin.");
        return; 
      }
      this.$http.post("UserLogs/ChangePasswordList", selectedUserIDs)
        .then(
          (response) => {
            toastr.success("Kullanıcı bilgilerini başarıyla güncelleyin.");
            this.selectedUsers = {};
            this.getDatas();
          },
          (err) => {
            console.log(err);
          }
        );
    },
  },
  created() {
    this.getDatas();
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UserLogs/UserList.vue